<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare class="loading-position animated fadeIn" size="60px"></RotateSquare>
    </div>
    <form v-else class="mb-5" @submit="ValidarForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <strong class="align-self-center">{{
                $t("sectionPessoa.novaPessoa")
              }}</strong>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <small>{{ $t("textObrigatorios") }}</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
                  <div class="form-group">
                    <label for>*{{ $t("sectionPessoa.pessoaNomeCompleto") }}</label>
                    <input v-model="viewModel.nome" class="form-control" type="text"
                      :placeholder="$t('sectionPessoa.pessoaNomeCompleto')" required />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
                  <div class="form-group">
                    <label for> {{ $t("sectionPessoa.pessoaCpf") }}</label>
                    <input v-model="viewModel.documento" class="form-control" type="text"
                      :placeholder="$t('sectionPessoa.pessoaCpf')" max="99999999999999" :required=verificaEstrangeiro() />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-5 col-xl-4">
                  <div class="form-group">
                    <label for> {{ $t("sectionPessoa.pessoaEmail") }}</label>
                    <input v-model="viewModel.email" class="form-control" type="email"
                      :placeholder="$t('sectionPessoa.pessoaEmail')" required />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>* {{ $t("sectionPessoa.pessoaGenero") }}</label>
                    <select v-model="viewModel.sexo" class="form-control" required>
                      <option value="0" selected>
                        {{ $t("sectionPessoa.pessoaOutros") }}
                      </option>
                      <option value="1">
                        {{ $t("sectionPessoa.pessoaMasculino") }}
                      </option>
                      <option value="2">
                        {{ $t("sectionPessoa.pessoaFeminino") }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-4">
                  <div class="form-group">
                    <label> {{ $t("sectionPessoa.pessoaDataNascimento") }}</label>
                    <div class="row">
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                        <select v-model="dia" class="form-control" :required=verificaEstrangeiro()>
                          <option value="" selected>
                            {{ $t("sectionPessoa.pessoaDiaNascimento") }}
                          </option>
                          <option v-for="dia in nascimento.dias" :key="dia" :value="dia">
                            {{ dia }}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                        <select v-model="mes" class="form-control" :required=verificaEstrangeiro()>
                          <option value="" selected>
                            {{ $t("sectionPessoa.pessoaMesNascimento") }}
                          </option>
                          <option v-for="mes in nascimento.meses" :key="mes" :value="mes">
                            {{ mes }}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-4 col-md-4 col-lg-4 col-xl-4">
                        <select v-model="ano" class="form-control" :required=verificaEstrangeiro()>
                          <option value="" selected>
                            {{ $t("sectionPessoa.pessoaAnoNascimento") }}
                          </option>
                          <option v-for="ano in nascimento.anos" :key="ano" :value="ano">
                            {{ ano }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-12 col-md-4 col-lg-2 col-xl-2">
                  <div class="form-group">
                    <label for>{{ $t("sectionPessoa.pessoaRG") }}</label>
                    <input v-model="viewModel.rg" class="form-control" type="text"
                      :placeholder="$t('sectionPessoa.pessoaRG')" />
                  </div>
                </div>
                <div v-if="!isCliente" class="col-sm-6 col-md-2 col-lg-2 col-xl-1">
                  <label for>{{ $t("sectionPessoa.pessoaStatusAtivo") }}</label>
                  <b-form-checkbox v-model="viewModel.ativo" name="check-button" switch>
                    {{ $t("sectionPessoa.pessoaStatusAtivoSim") }}
                  </b-form-checkbox>
                </div>
              </div>
              <div v-if="!isCliente" class="row">
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="form-group">
                    <label for>{{ $t("sectionPessoa.pessoaObs") }}</label>
                    <b-form-textarea v-model="viewModel.observacao" :placeholder="$t('sectionPessoa.pessoaObs')" rows="10"
                      max-rows="10"></b-form-textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="viewModel.tipoContato === 0">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <div class="d-flex">
                <strong class="align-self-center">{{
                  $t("sectionPessoa.pessoaTel")
                }}</strong>
                <button v-if="!isCliente" class="ml-auto btn btn-primary" type="button"
                  :title="$t('sectionPessoa.adicionarMaisNumeros')" @click="AdicionarTelefone()">
                  <i class="fa fa-plus"></i>
                </button>
              </div>
            </header>
            <div class="card-body">
              <div class="row">
                <div v-for="(item, index) in viewModel.telefones" :key="index"
                  class="col-sm-12 col-md-6 col-lg-4 col-xl-3">
                  <div class="form-group">
                    <label>{{ $t("sectionPessoa.pessoaNumero") }}</label>
                    <div class="input-group mb-3">
                      <input v-if="!isCliente" :id="index" v-model="viewModel.telefones[index].numero"
                        :required=verificaEstrangeiro() disabled type="tel" class="form-control"
                        aria-label="Recipient's username" aria-describedby="button-addon2" />
                      <label v-if="isCliente">{{
                        viewModel.telefones[index].numero
                      }}</label>
                      <div v-if="!isCliente && index !== 0" class="input-group-append">
                        <button id="button-addon2" class="btn btn-danger" type="button"
                          :title="$t('sectionPessoa.removerEsteNumero')" @click="RemoverTelefone(index)">
                          <i class="fas fa-times"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row" v-if="viewModel.tipoContato != 0">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <div class="d-flex">
                <strong class="align-self-center">{{
                  $t("textIdentificacao")
                }}</strong>

              </div>
            </header>
            <div class="card-body">
              <div class="row">
                <div v-for="(item, index) in viewModel.telefones" :key="index"
                  class="col-sm-12 col-md-6 col-lg-4 col-xl-3">
                  <div class="form-group">
                    <label>{{ $t("textUsername") }}</label>
                    <div class="input-group mb-3">
                      <input v-if="!isCliente" :id="index" v-model="viewModel.telefones[index].numero"
                        :required=verificaEstrangeiro() type="tel" class="form-control" aria-label="Recipient's username"
                        aria-describedby="button-addon2" />
                      <label v-if="isCliente">{{
                        viewModel.telefones[index].numero
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header">
              <div class="d-flex">
                <strong class="align-self-center">{{
                  $t("sectionPessoa.endereco")
                }}</strong>
              </div>
            </header>
            <div class="card-body">
              <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-group">
                    <label> {{ $t("sectionPessoa.pessoaCep") }}</label>
                    <input v-model="viewModel.endereco.cep" type="number" class="form-control" @change="ConsultarCep" />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="form-group">
                    <label> {{ $t("sectionPessoa.pessoaRua") }}</label>
                    <input v-model="viewModel.endereco.rua" type="text" class="form-control"
                      :placeholder="$t('sectionPessoa.pessoaRuaAV')" maxlength="200" />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label> {{ $t("sectionPessoa.pessoaNumero") }}</label>
                    <input v-model="viewModel.endereco.numero" type="text" class="form-control" maxlength="30" />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-4 col-lg-4 col-xl-2">
                  <div class="form-group">
                    <label> {{ $t("sectionPessoa.bairro") }}</label>
                    <input v-model="viewModel.endereco.bairro" type="text" class="form-control" maxlength="60" />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-3">
                  <div class="form-group">
                    <label> {{ $t("sectionPessoa.cidade") }}</label>
                    <input v-model="viewModel.endereco.cidade" type="text" class="form-control" maxlength="60" />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-4 col-xl-4">
                  <div class="form-group">
                    <label>{{ $t("sectionPessoa.complemento") }}</label>
                    <input v-model="viewModel.endereco.complemento" type="text" class="form-control"
                      :placeholder="$t('sectionPessoa.pessoaApCasaFundos')" maxlength="30" />
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-3 col-xl-2">
                  <div class="form-group">
                    <label for> {{ $t("sectionPessoa.uf") }}</label>
                    <select v-model="viewModel.endereco.uf" class="form-control" :required=verificaEstrangeiro()>
                      <option disabled selected value>
                        {{ $t("sectionAtendimento.atendimentoSelecione") }}
                      </option>
                      <option value="AC">AC</option>
                      <option value="AL">AL</option>
                      <option value="AP">AP</option>
                      <option value="AM">AM</option>
                      <option value="BA">BA</option>
                      <option value="CE">CE</option>
                      <option value="DF">DF</option>
                      <option value="ES">ES</option>
                      <option value="GO">GO</option>
                      <option value="MA">MA</option>
                      <option value="MT">MT</option>
                      <option value="MS">MS</option>
                      <option value="MG">MG</option>
                      <option value="PA">PA</option>
                      <option value="PB">PB</option>
                      <option value="PR">PR</option>
                      <option value="PE">PE</option>
                      <option value="PI">PI</option>
                      <option value="RJ">RJ</option>
                      <option value="RN">RN</option>
                      <option value="RS">RS</option>
                      <option value="RO">RO</option>
                      <option value="RR">RR</option>
                      <option value="SC">SC</option>
                      <option value="SP">SP</option>
                      <option value="SE">SE</option>
                      <option value="TO">TO</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-success mr-2" type="submit">
            {{ $t("btSalvar") }}
          </button>
          <button v-if="!isCliente" class="btn btn-secondary" type="reset" @click="$router.push('/pessoa')">
            Voltar
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";

export default {
  name: "NovoPessoa",
  components: {
    RotateSquare
  },
  data() {
    return {
      loading: false,
      contaOptions: [],
      isCliente: false,
      nascimento: { dias: [], meses: [], anos: [] },
      dia: "",
      mes: "",
      ano: "",
      viewModel: {
        id: this.$store.state.emptyGuid,
        ativo: true,
        email: "",
        nome: "",
        documento: "",
        rg: "",
        observacao: "",
        sexo: 0,
        nascimento: "",
        contaId: "",
        telefones: [],
        tipoContato: 0,
        endereco: {
          id: this.$store.state.emptyGuid,
          cep: "",
          bairro: "",
          cidade: "",
          complemento: "",
          uf: "",
          numero: "",
          rua: ""
        }
      }
    };
  },
  mounted() {
    let id = this.$route.params.id;
    let tipo = this.$route.params.tipo;
    let contaId = this.$route.params.contaId;
    if (this.$store.getters.isLoggedIn) {
      this.viewModel.contaId = this.$store.getters.getAutenticacao.contaSelecionadaId;
    }
    this.CarregarNascimento();
    if (id && contaId) {
      this.isCliente = true;
      this.viewModel.contaId = contaId;
      this.Obter(id, tipo);
    } else if (id) {
      this.Obter(id, tipo);
    } else {
      this.AdicionarTelefone();
    }
  },
  created() { },
  methods: {
    validarCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, '');
      if (cpf == '') return false;
      // Elimina CPFs invalidos conhecidos	
      if (cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999")
        return false;
      // Valida 1o digito	
      let add = 0;
      for (let i = 0; i < 9; i++)
        add += parseInt(cpf.charAt(i)) * (10 - i);
        let rev = 11 - (add % 11);
      if (rev == 10 || rev == 11)
        rev = 0;
      if (rev != parseInt(cpf.charAt(9)))
        return false;
      // Valida 2o digito	
      add = 0;
      for (let i = 0; i < 10; i++)
        add += parseInt(cpf.charAt(i)) * (11 - i);
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11)
        rev = 0;
      if (rev != parseInt(cpf.charAt(10)))
        return false;
      return true;
    },
    verificaEstrangeiro() {
      if (this.$i18n.locale == "es") {
        return false;
      } else {
        return true;
      }
    },
    ConsultarCep() {
      if (!this.viewModel.endereco.cep) return;
      this.$http({
        url: "pessoa/obter-cep/" + this.viewModel.endereco.cep,
        method: "GET"
      })
        .then((resposta) => {
          this.viewModel.endereco.bairro = resposta.data.bairro;
          this.viewModel.endereco.uf = resposta.data.uf;
          this.viewModel.endereco.cidade = resposta.data.localidade;
          this.viewModel.endereco.rua = resposta.data.logradouro;
          this.viewModel.endereco.bairro = resposta.data.bairro;
        })
        .catch(() => { });
    },
    RemoverTelefone(index) {
      let id = this.viewModel.telefones[index].id;
      console.log(id);
      if (id === this.$store.state.emptyGuid) {
        this.viewModel.telefones.splice(index, 1);
      } else {
        this.$http({
          url: "pessoa/remover-telefone/" + id + "/" + this.viewModel.contaId,
          method: "GET"
        })
          .then(() => {
            this.viewModel.telefones.splice(index, 1);
          })
          .catch(() => { });
      }
    },
    AdicionarTelefone() {
      this.viewModel.telefones.push({
        id: this.$store.state.emptyGuid,
        numero: "",
        contaId: this.viewModel.contaId
      });
    },
    ValidarForm(evt) {
      evt.preventDefault();

      if(this.verificaEstrangeiro() && !this.validarCPF(this.viewModel.documento))
      {
        alert("CPF INVALIDO")
        return;
      }

      this.viewModel.nascimento = new Date(this.ano, this.mes - 1, this.dia);
      if (this.viewModel.id !== this.$store.state.emptyGuid) this.Editar();
      else this.Novo();
    },
    ObterCliente(id, contaId) {
      this.loading = true;
      this.$http({
        url: "cliente/obter/" + id + "/" + contaId,
        method: "GET"
      })
        .then((resposta) => {
          this.loading = false;
          this.AjustarViewModel(resposta);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    AjustarViewModel(resposta) {
      resposta.data.nascimento = new Date(resposta.data.nascimento);
      if (resposta.data.nascimento.getTime() > -1924980812000) {
        this.dia = resposta.data.nascimento.getDate();
        this.mes = resposta.data.nascimento.getMonth() + 1;
        this.ano = resposta.data.nascimento.getFullYear();
      }
      if (resposta.data.estrangeiro) {
        this.$i18n.locale = "es";
      } else {
        this.$i18n.locale = "pt-BR";
      }
      this.viewModel = resposta.data;
    },
    Obter(id, tipoContato) {
      this.loading = true;
      this.$http({
        url: "pessoa/obter/" + id + "/" + this.viewModel.contaId + "/" + tipoContato,
        method: "GET"
      })
        .then((resposta) => {
          this.loading = false;
          this.AjustarViewModel(resposta);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Novo() {
      this.loading = true;
      this.$http({
        url: "pessoa/novo",
        data: this.viewModel,
        method: "POST"
      })
        .then(() => {
          this.loading = false;
          this.$router.push("/pessoa");

          const personChangedSuccessfully = this.$t(
            "infoMessages.personChangedSuccessfully"
          );

          this.$notify({
            data: [personChangedSuccessfully],
            type: "success",
            duration: 10000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    Editar() {
      this.loading = true;
      this.$http({
        url: "pessoa/editar",
        data: this.viewModel,
        method: "PUT"
      })
        .then(() => {
          this.loading = false;
          if (!this.isCliente) this.$router.push("/pessoa");

          const personSuccessfullyEdited = this.$t(
            "infoMessages.personSuccessfullyEdited"
          );

          this.$notify({
            data: [personSuccessfullyEdited],
            type: "success",
            duration: 10000
          });
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 10000
          });
        });
    },
    CarregarNascimento() {
      for (let dia = 1; dia <= 31; dia++) {
        this.nascimento.dias.push(dia);
      }

      for (let mes = 1; mes <= 12; mes++) {
        this.nascimento.meses.push(mes);
      }

      let agora = new Date();
      for (let ano = 1910; ano <= agora.getFullYear(); ano++) {
        this.nascimento.anos.push(ano);
      }
    }
  }
};
</script>
